module.exports = __webpack_public_path__ + "images/product-group-placeholder-a9b39aa6.jpg";